export default __webpack_public_path__ + "static/media/110_background.5689a09a.gif";